import { border, text } from '@guardian/source-foundations';

export const accordionThemeDefault = {
	accordion: {
		textPrimary: text.primary,
		borderPrimary: border.primary,
	},
};
